import { render, staticRenderFns } from "./researchResults.vue?vue&type=template&id=d009d1e4&scoped=true&"
import script from "./researchResults.vue?vue&type=script&lang=js&"
export * from "./researchResults.vue?vue&type=script&lang=js&"
import style0 from "./researchResults.vue?vue&type=style&index=0&id=d009d1e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d009d1e4",
  null
  
)

export default component.exports